export const nl = {
  open: 'Open',
  close: 'Sluiten',
  share: 'Deel op',
  languages: 'Talen',
  footer: {
    copyright: '© 2018 Codeurs, Alle rechten voorbehouden.'
  },
  contact: {
    name: 'Naam',
    email: 'Email',
    question: 'Bericht',
    submit: 'Verzenden',
    thanks: 'Bedankt voor uw bericht'
  },
  error404: {
    title: 'Pagina niet gevonden',
    text: 'De pagina die je probeert te bereiken is niet beschikbaar of is onlangs verwijderd.',
    btn: 'Ga naar startpagina'
  },
  cookies: {
    text: 'Deze website gebruikt cookies om uw surfervaring te verbeteren.',
    accept: 'Cookies accepteren',
    decline: 'Cookies weigeren'
  },
  header: {
    top: {
      text: 'Andere informatie en diensten van de overheid',
      link: 'https://www.belgium.be/nl'
    }
  },
  previewlink: {readmore: 'Lees meer'},

  contentpage: {
    related_publication: 'Verwante publicatie',
    related_articles: 'Verwante artikels'
  },
  library: {
    all_years: 'Alle jaren',
    filter: {
      type: 'Filter per type:',
      category: 'Filter per niveau:',
      themes: 'Filter per thema:'
    },
    published: 'Gepubliceerd op',
    search: 'Zoeken in ',
    select_year: 'Selecteer een jaartal',
    loadmore: 'Laad meer artikels',
    title: 'Filter op jaar'
  },
  sidebar: {related: "Gerelateerde pagina's"},
  search: {
    title: 'Zoekresultaten',
    noresult: 'Er zijn geen zoekresultaten gevonden'
  },
  sharepage: 'Deel pagina',
  sitemap: {
    home: 'De homepage',
    home2050: 'De 2050 homepage',
    homecbam: 'De CBAM homepage'
  },
  newsletter: {
    btn: 'Nieuwsbrief',
    label: 'Ga naar nieuwsbrief',
    submit: 'Schrijf in op de nieuwsbrief',
    error:
      'Er is een fout opgetreden bij het verzenden van het formulier. Probeer het later opnieuw.'
  }
}
